<template>
  <div>
    <div class="ibox float-e-margins">
      <div class="ibox-title">
        <h5>Tags</h5>
        <div class="ibox-tools">
          <a class="collapse-link">
            <i class="fa fa-chevron-up"></i>
          </a>
        </div>
      </div>
      <div class="ibox-content table-responsive col-lg-12">
        <table class="table table-striped table-bordered table-hover dataTables-example">
          <thead>
          <tr>
            <th>Tag</th>
            <th>Sites</th>
            <th>Videos</th>
            <th>Used</th>
            <th>&nbsp;</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="tag in tags.tags" :key="tag.tag">
            <td>{{ tag.tag }}</td>
            <td>{{ tag.count }}</td>
            <td>{{ tags.videos[tag.tag] !== undefined ? tags.videos[tag.tag].count : 0 }}</td>
            <td></td>
            <td><a @click="importVideos(tag.tag)">Import more</a></td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <th>Tag</th>
            <th>Videos</th>
            <th>Clean</th>
            <th>Used</th>
            <th>&nbsp;</th>
          </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Tags',
  data () {
    return {
      tags: []
    }
  },
  mounted () {
    this.getTags()
  },
  methods: {
    getTags () {
      axios.get('/am/tags')
        .then(r => {
          this.tags = r.data
        })
        .catch()
    },
    importVideos (tag) {
      let count = this.tags.videos[tag] !== undefined ? this.tags.videos[tag].count : 0
      axios.get('/am/videos?tag=' + tag + '&offset=' + count).then(r => {
        this.getTags()
      }).catch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Manager/Tags.vue